wbApp.factory('userSettingSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var UserSetting = $resource('/Api/UserSetting/Get', {}, {
            'get': { method: 'GET', isArray: false, url: '/Api/UserSetting/Get' },
            'save': { method: 'POST', isArray: false, url: '/Api/UserSetting/Save' },
        });

        var _userSetting = {};

        function getAsync() {

            var deferred = $q.defer();
            _userSetting.$promise = deferred.promise;

            repositorySvc.customGet('get', UserSetting, {}, function (data) {
                angular.extend(_userSetting, data);
                deferred.resolve(_userSetting);
            }, function (errorResult) {
                deferred.reject(errorResult);
            });

            return _userSetting;
        }

        function saveAsync(setting, success, error) {
            repositorySvc.customPost(
                'save',
                UserSetting,
                setting || _userSetting,
                function (data) {
                    angular.extend(_userSetting, data);
                    if (success) {
                        success(data);
                    }
                },
                error);
        }

        getAsync();

        return {
            getAsync: getAsync,
            settings: _userSetting,
            saveAsync: saveAsync
        }
    }]);